import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormGenerator from "../../../../../../Components/FormGenerator";

import { SetOrganisationContract, UpdateOrganisationContractError } from "./OrganisationContractActions";
import {
  useParams
} from "react-router-dom";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";

import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleOutlinedIcon from '@material-ui/icons/RemoveCircleOutlined';
import { Divider } from "@material-ui/core";
import InputWithDropdownComponent from "../../../../../../Components/FormGenerator/input_with_dropdown";
import InputComponent from "../../../../../../Components/FormGenerator/input_component";
import { KeyboardDatePicker } from "@material-ui/pickers";


// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function Contract(props) {

  const dispatch = useDispatch();

  const {
    start_date_with_client,
    tenure,
    financial_invoice_status,
    date_of_first_revenue,
    date_of_most_recent_revenue,
    admin_time,
    lifetime_income_from_client,
    date_account_closed,
    legal_contracts,
    time_from_start_date,
    time_to_end_date,
    total_time,
    revenue,
    revenue_currency_id,
    variation_agreement,
    NDA,
    PES_required,
    SLA,
    variation_agreement_documents,
    legal_contract_final_documents,
    legal_contract_final,
    legal_contract_review_notes,
    legal_contract_start_date,
    legal_contract_expiry_date,
    incomes,
    contract_rolling,
    fiscal_year
  } = useSelector((state) => state.organisationContractReducer.data);

  const {
    currencies,
  } = useSelector((state) => state.commonReducer.organisationDropdowns);
  const userRole = useSelector((state) => state.commonReducer.role)
  const errors = useSelector(state => state.organisationContractReducer.errors);

  const [loading, setLoading] = useState(false);
  const [apiStartData, setApiStartData] = useState('');
  const [apiEndData, setApiEndData] = useState('');
  const [apiTotalTimeData, setApiTotalTimeData] = useState('');
  const [apiTenureData, setApiTenureData] = useState('');
  let { id } = useParams();

  // useEffect(() => {
  //    setLoading(true);
  //    DataService.getDirectData(`/organisation_contract_phases/3`)
  //    .then((response) => {
  //      let listData=response["data"];
  //      setApiStartData(listData.time_from_start_date);
  //      setApiEndData(listData.time_to_end_date);  
  //      setApiTotalTimeData(listData.total_time);
  //      setApiTenureData(listData.tenure);
  //      setLoading(false);
  //    })
  //    .catch((err) => {});
  // }, []);

  const handleInputChange = (value, index, type, key) => {
    props.setSomeChangeDetected(true)
    const updatedForm = formInput;
    let keyIndex = index;
    if (key && !type) {
      keyIndex = formInput.findIndex((item) => item.name === key);
      updatedForm[keyIndex]["value"] = value;
    }
    else if (!type) {
      updatedForm[index]['value'] = value;
    } else {
      updatedForm[index][type] = value;
    }
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item) => {
      formData[item.name] = item.value ?? "";
      formData[item.inputName] = item.inputValue ?? "";
      formData[item.selectName] = item.selectValue ?? "";
    });
    dispatch(SetOrganisationContract(formData));
    dispatch(UpdateOrganisationContractError(updatedForm[index].name));
  }

  useEffect(() => {
    if (incomes?.length) {
      const updatedForm = formInput;
      const keyIndex = formInput.findIndex((item) => item.name === 'incomes');
      if (updatedForm[keyIndex]) updatedForm[keyIndex]["value"] = incomes;
      setFormInput(updatedForm);
    }
  }, [incomes])

  const OnlyAcuityArray = [
    "NDA",
    "legal_contract_final_documents"
  ];

  const formArray = [
    {
      componentType: "datePicker",
      required: true,
      label: "Start date with client activity*",
      name: "start_date_with_client",
      value: start_date_with_client,
      placeholder: "Start date with client activity",
      helperText: errors.start_date_with_client && "Please select a date",
      handleChange: handleInputChange
    },
    {
      componentType: "input",
      type: "text",
      label: "Time from start date",
      name: "time_from_start_date",
      handleChange: handleInputChange,
      value: time_from_start_date,
      disabled: true
    },
    {
      componentType: "rederComponent",
      name: "fiscal_year",
      value: fiscal_year,
      component: <FiscalYearComponent
        handleChange={handleInputChange}
        name="fiscal_year"
        value={fiscal_year}
      />
    },
    {
      componentType: "input",
      type: "text",
      label: "Time to contract expiry date",
      name: "time_to_end_date",
      handleChange: handleInputChange,
      value: time_to_end_date,
      disabled: true
    },
    {
      componentType: "datePicker",
      required: true,
      label: "Account closed date",
      // label: "Admin time/month",
      name: "date_account_closed",
      value: date_account_closed,
      // helperText: errors.date_account_closed && "Please select a date",
      handleChange: handleInputChange
    },
    {
      componentType: "input",
      type: "text",
      label: "Total time start to account closed date",
      name: "total_time",
      handleChange: handleInputChange,
      value: total_time,
      disabled: true
    },
    {
      componentType: "uploadFiles",
      name: "legal_contract_final_documents",
      label: "Legal contract - working version",
      handleChange: handleInputChange,
      value: legal_contract_final_documents,
      labelStyle: { textTransform: "inherit" }
    },
    // {
    //   componentType: "select",
    //   label: "Legal Contracts",
    //   name: "legal_contracts",
    //   value: legal_contracts,
    //   placeholder: "Legal contracts",
    //   selectOptions: [
    //     { id: 'Yes', value: "Yes", name: "Yes" },
    //     { id: "No", value: "No", name: "No" },
    //   ],
    //   handleChange: handleInputChange,
    // },
    {
      componentType: "select",
      label: "Variation agreement",
      name: "variation_agreement",
      value: variation_agreement,
      placeholder: "Variation agreement",
      selectOptions: [
        { id: 'Yes', value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "NDA required",
      name: "NDA",
      value: NDA,
      placeholder: "NDA",
      selectOptions: [
        { id: 'Yes', value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "PES required",
      name: "PES_required",
      value: PES_required,
      placeholder: "PES required",
      selectOptions: [
        { id: 'Yes', value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "SLA",
      name: "SLA",
      value: SLA,
      placeholder: "SLA",
      selectOptions: [
        { id: 'Yes', value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Tenure",
    //   name: "tenure",
    //   placeholder: "Tenure",
    //   handleChange: handleInputChange,
    //   value: tenure
    // },
    {
      componentType: "uploadFiles",
      name: "variation_agreement_documents",
      label: "Legal contract, variation agreement, NDA and associated documentation - final versions",
      handleChange: handleInputChange,
      value: variation_agreement_documents,
      labelStyle: { textTransform: "none" }
    },
    {
      componentType: "select",
      label: "Legal contract - final",
      name: "legal_contract_final",
      value: legal_contract_final,
      placeholder: "Legal contract - final",
      selectOptions: [
        { id: 'Yes', value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "Contract rolling",
      name: "contract_rolling",
      value: contract_rolling,
      placeholder: "Contract rolling",
      selectOptions: [
        { id: 'Yes', value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      multiline: true,
      label: "Legal contract review notes",
      name: "legal_contract_review_notes",
      placeholder: "Legal contract review notes",
      handleChange: handleInputChange,
      value: legal_contract_review_notes
    },
    {
      componentType: "datePicker",
      // required: true,
      label: "Legal contract start date",
      name: "legal_contract_start_date",
      value: legal_contract_start_date,
      placeholder: "Legal contract start date",
      handleChange: handleInputChange
    },
    {
      componentType: "datePicker",
      // required: true,
      label: "Legal contract expiry date",
      name: "legal_contract_expiry_date",
      value: legal_contract_expiry_date,
      placeholder: "Legal contract expiry date",
      handleChange: handleInputChange
    },
    {
      componentType: "input",
      type: "text",
      label: "Financial invoice status",
      name: "financial_invoice_status",
      placeholder: "Financial invoice status",
      handleChange: handleInputChange,
      value: financial_invoice_status
    },
    {
      componentType: "datePicker",
      required: true,
      label: "Date of first revenue",
      name: "date_of_first_revenue",
      value: date_of_first_revenue,
      handleChange: handleInputChange
    },
    {
      componentType: "datePicker",
      required: true,
      label: "Date of most recent revenue",
      name: "date_of_most_recent_revenue",
      value: date_of_most_recent_revenue,
      handleChange: handleInputChange
    },
    {
      componentType: "input",
      type: "text",
      label: "Lifetime income from client",
      name: "lifetime_income_from_client",
      placeholder: "Lifetime income from client",
      handleChange: handleInputChange,
      value: lifetime_income_from_client
    },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Income per Year",
    //   name: "income_per_year",
    //   placeholder: "Income per Year",
    //   handleChange: handleInputChange,
    //   value: income_per_year
    // },
    {
      componentType: "rederComponent",
      name: "incomes",
      value: incomes,
      component: <IncomePerYearComponent
        handleChange={handleInputChange}
        name="incomes"
        value={incomes}
        componentObject={[
          {
            componentType: "inputWithDropdown",
            type: "number",
            inputName: "income",
            selectName: "currency_id",
            inputPlaceholder: "$00,000,000",
            selectPlaceholder: "USD",
            apiVariable: "currencies",
            selectOptions: currencies,
            selectWithAutoComplete: true
          },
        ]}
      />
    },
    {
      componentType: "inputWithDropdown",
      label: "Revenue currency",
      type: "number",
      inputName: "revenue",
      selectName: "revenue_currency_id",
      inputPlaceholder: "$00,000,000",
      selectPlaceholder: "USD",
      // apiVariable: "currencies",
      selectOptions: currencies,
      handleInputChange: handleInputChange,
      handleSelectChange: handleInputChange,
      inputValue: revenue,
      selectValue: revenue_currency_id,
      selectWithAutoComplete: true
    },
    {
      componentType: "input",
      required: true,
      label: "Admin time/month",
      multiline: true,
      name: "admin_time",
      value: admin_time,
      handleChange: handleInputChange
    },
    // {
    //   componentType: "uploadFiles",
    //   name: "variation_agreement_documents",
    //   label: "Variation Agreement Documents",
    //   handleChange: handleInputChange,
    //   value: variation_agreement_documents,
    // },
    // {
    //   componentType: "uploadFiles",
    //   name: "transcription_documents",
    //   label: "Associated Documentation",
    //   handleChange: handleInputChange,
    //   value: general_documents,
    // },
    // {
    //   componentType: "uploadFiles",
    //   name: "transcription_documents",
    //   label: "Transcription Documents",
    //   handleChange: handleInputChange,
    //   value: general_documents,
    // },
    // {
    //   componentType: "uploadFiles",
    //   name: "transcription_documents",
    //   label: "Transcription Documents",
    //   handleChange: handleInputChange,
    //   value: general_documents,
    // },
  ];

  const newArray = userRole !== "admin" ? formArray.filter((array) => OnlyAcuityArray.includes(array.name)) : formArray

  const [formInput, setFormInput] = useState(newArray);

  useEffect(() => {
    setFormInput(newArray);
  }, [errors]);

  return (
    <FormGenerator
      children={formInput}
      handleNext={props.handleNext}
      nextIndex={5}
      setId={props.setId}
      moduleName="organization"
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  helperText: {
    color: "red"
  },
  disabled: {
    background: '#f5f2f2'
  },

  textInput: {
    '& input::placeholder': {
      color: '#808080',
      opacity: 1
    }
  }
}));

const IncomePerYearComponent = (props) => {
  console.log("props", props)
  const classes = useStyles();
  const { name, handleChange } = props;
  const [incomePerYear, setIncomePerYear] = useState([]);

  const {
    incomes
  } = useSelector((state) => state.organisationContractReducer.data);


  const handleInputChange = useCallback((value, index, type, dynamicField) => {
    setIncomePerYear(prevState => {
      prevState[index] = { ...prevState[index] };
      if (type !== "") {
        type === "inputValue" ? prevState[index]["income"] = value : prevState[index]["currency_id"] = value;
      } else {
        prevState[index][dynamicField] = value;
      }
      return [...prevState]
    });
    incomePerYear?.length && handleChange(incomePerYear, 0, '', name)
  }, [incomePerYear]);

  useEffect(() => {
    if (incomes?.length)
      setIncomePerYear(incomes);
    else
      setIncomePerYear([{
        income: "",
        currency_id: "",
        year: ""
      }]);
  }, [incomes])

  const handleIncome = (isAdd, index) => {
    if (isAdd) {
      const newCall = {
        income: "",
        currency_id: "",
        year: ""
      }
      const newItem = [...incomePerYear, ...[newCall]]
      setIncomePerYear(newItem)
      handleChange(newItem, 0, '', name)
    } else {
      incomePerYear.splice(index, 1);
      handleChange(incomePerYear, 0, '', name)
      setIncomePerYear([...incomePerYear])
    }
  }

  return (
    <Grid container className={classes.gridRoot}>
      <Grid item xs={12} md={4} >
        Income per year
      </Grid>
      <Grid item xs={12} md={7}>
        {incomePerYear?.map((item, index) => {
          const formInputFields = {
            ...props?.componentObject[0]
          };
          formInputFields.handleInputChange = handleInputChange;
          formInputFields.handleSelectChange = handleInputChange;
          formInputFields.inputValue = item.income;
          formInputFields.selectValue = item.currency_id
          formInputFields.index = index
          formInputFields.gridSize = {
            select: 4,
            input: 8
          }
          return (
            <>
              <Grid container spacing={1}>
                <Grid item xs={9} style={{ marginTop: "-11px" }}>
                  <InputWithDropdownComponent
                    key={index}
                    incomePerYear="yes"
                    componentObject={formInputFields}
                  />
                </Grid>
                <Grid item xs={2} style={{ marginTop: "-11px" }}>
                  <InputComponent key={index} componentObject={{
                    type: "text",
                    name: "year",
                    isDynamicField: "year",
                    placeholder: "Year",
                    handleChange: handleInputChange,
                    value: item.year,
                    index: index,
                    hideLabel: true,
                  }} />
                </Grid>
                <Grid item xs={1} style={{ marginTop: "-11px" }}>
                  {!index ?
                    <AddCircleIcon
                      type="submit"
                      onClick={() => handleIncome(true, 0)}
                      fontSize="large"
                      color="primary"
                      style={{ cursor: 'pointer'}} /> :
                    <RemoveCircleOutlinedIcon type={'submit'}
                      fontSize="large"
                      onClick={() => handleIncome(false, index)}
                      style={{
                        cursor: 'pointer',
                        color: 'red'
                      }} />}
                </Grid>
              </Grid>
              {index === (incomePerYear.length - 1) && < Divider />}
            </>
          )
        })}
      </Grid>
    </Grid>)
}

const FiscalYearComponent = (props) => {
  const classes = useStyles();
  const { name, handleChange } = props;
  const [dateValue, setDateValue] = useState({})
  const {
    fiscal_year
  } = useSelector((state) => state.organisationContractReducer.data);

  const handleInputChange = useCallback((key, value) => {
    setDateValue({ ...dateValue, [key]: value });
    handleChange({ ...dateValue, [key]: value }, 0, '', name)
  }, [dateValue]);

  useEffect(() => {
    if (fiscal_year)
      setDateValue({ ...dateValue, ...fiscal_year });
  }, [fiscal_year])

  return (
    <Grid container className={classes.gridRoot}>
      <Grid item xs={12} md={4} >
        Fiscal year
      </Grid>
      <Grid container xs={12} md={7}>
        <Grid item xs={1} md={1}>
          From
        </Grid>
        <Grid item xs={5} md={5} style={{ marginTop: "-11px" }}>
          <KeyboardDatePicker
            disableToolbar
            fullWidth
            views={['month']}
            placeholder="Month"
            inputVariant="outlined"
            size="small"
            format="MMM"
            maxDate={new Date(dateValue?.to_month)}
            value={dateValue?.from_month || undefined}
            defaultValue={new Date(2022, 0, 1)}
            disablePast={false}
            onChange={(val) => {
              handleInputChange('from_month', val)
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={1} md={1} style={{ textAlign: 'center' }}>
          To
        </Grid>
        <Grid item xs={5} md={5} style={{ marginTop: "-11px" }}>
          <KeyboardDatePicker
            disableToolbar
            fullWidth
            views={['month']}
            placeholder="Month"
            inputVariant="outlined"
            size="small"
            format="MMM"
            minDate={new Date(dateValue?.from_month)}
            defaultValue={new Date(2022, 11, 1)}
            value={dateValue?.to_month || undefined}
            disablePast={false}
            onChange={(val) => {
              handleInputChange('to_month', val)
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            InputProps={{ readOnly: true }}
          /></Grid></Grid>
    </Grid>)
}